import { mediaUrl } from "../../lib/api";
import { Reveal } from "../Reveal";
import { useLang } from "../../context/LanguageContext";
import { ExternalLink } from "lucide-react";

export function SpeakerSection({ course }) {
  const { t } = useLang();
  return (
    <section data-testid="course-speaker" className="relative isolate overflow-hidden bg-[#0B1220] py-20 md:py-28 text-white">
      <div className="absolute -bottom-40 -left-24 h-[520px] w-[520px] rounded-full bg-[#1452F0]/18 blur-[130px] pointer-events-none" />
      <div className="relative px-6 md:px-12 max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5">
          <div className="overflow-hidden rounded-sm border border-white/10 glow-azure">
            {course.speaker_photo && (
              <img
                data-testid="speaker-section-photo"
                src={mediaUrl(course.speaker_photo)}
                alt={course.speaker_name}
                className="w-full h-[480px] lg:h-[600px] object-cover object-top"
              />
            )}
          </div>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-7">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-[#5B9DFF]">{t("speaker.overline")}</span>
          <h2 className="font-heading text-4xl lg:text-6xl font-light tracking-tight mt-3 silver-text">{course.speaker_name}</h2>
          <div className="text-[#5B9DFF] mt-2 text-lg">{course.speaker_qualification}</div>

          {course.speaker_claim && (
            <p className="font-heading text-2xl lg:text-3xl font-light italic mt-8 text-[#C9D2E3] leading-snug">
              “{course.speaker_claim}”
            </p>
          )}

          <p className="mt-8 text-[#9AA7BD] font-light leading-relaxed max-w-2xl">{course.speaker_bio}</p>

          {course.speaker_social?.length > 0 && (
            <div className="mt-8 flex flex-wrap gap-4">
              {course.speaker_social.map((s, i) =>
                s.url ? (
                  <a
                    key={i}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`speaker-social-${i}`}
                    className="inline-flex items-center gap-2 border border-white/25 hover:border-[#5B9DFF] hover:text-[#5B9DFF] transition-colors rounded-sm px-4 py-2 text-sm"
                  >
                    {s.label || "Link"} <ExternalLink className="h-3.5 w-3.5" />
                  </a>
                ) : null
              )}
            </div>
          )}
        </Reveal>
      </div>
    </section>
  );
}
